import script from "./Enlargement.vue?vue&type=script&lang=ts&setup=true"
export * from "./Enlargement.vue?vue&type=script&lang=ts&setup=true"

import "./Enlargement.vue?vue&type=style&index=0&id=7d98b84a&lang=scss"

const __exports__ = script;

export default __exports__